import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AuthOptions } from "msal/lib-commonjs/Configuration";

// Environment configuration provider.  From https://juristr.com/blog/2018/01/ng-app-runtime-config/#runtime-configuration

// TODO: make it a model.
export interface AppConfig {
  microfrontends: {
    [name: string]: string
  },
  cognito: {
    amplifyParams: {
      aws_project_region: string;
      aws_cognito_region: string;
      aws_user_pools_id: string;
      aws_user_pools_web_client_id: string;
    };
    oauth: {
      domain: string;
      scope: string[];
      redirectSignIn: string;
      redirectSignOut: string;
      responseType: string;
    };
    urlParams: {
      host: string;
      endpoint: string;
    };
  };
  msalAuth: AuthConfig;
  rest_url: string;
  upload_service_url: string;
  file_storage_api_url: string;
  userpermissions_api_url: string;
  experimentalFeatures: {
    [key: string]: any;
  };
  enable_entitlement_enforcement: boolean;
}


export interface AuthTimeoutOptions {
  idleSecondsBeforeWarningStart: number;
  warningSecondsBeforeLogout: number;
  tokenRefreshSeconds: number;
}
export interface AuthConfig extends AuthOptions {
  forgotPasswordAuthority: string;
  forgotPasswordUrl: string;
  forgotPasswordPolicy: string;
  timeouts?: AuthTimeoutOptions;
}



@Injectable({
  providedIn: "root"
})
export class AppConfigService {
  private appConfig: AppConfig;

  constructor(private http: HttpClient) { }

  async loadAppConfig() {
    const data: any = await this.http
      .get("/assets/data/appConfig.json")
      .toPromise();
    this.appConfig = data;
    this.setConfigDefaults();
  }

  private setConfigDefaults() {
    this.appConfig.msalAuth.redirectUri = this.appConfig.msalAuth.redirectUri; //  'http://localhost:4200/digitization'
    // this.appConfig.auth.postLogoutRedirectUri = this.appConfig.auth.postLogoutRedirectUri || this.appConfig.auth.redirectUri;

    let timeouts = this.appConfig.msalAuth.timeouts || {} as AuthTimeoutOptions;
    timeouts.idleSecondsBeforeWarningStart = timeouts.idleSecondsBeforeWarningStart || 9000; // Executes when inactive for 15 min
    timeouts.warningSecondsBeforeLogout = timeouts.warningSecondsBeforeLogout || 300;  // Executes a 5 minute countdown prior to Timeout
    timeouts.tokenRefreshSeconds = timeouts.tokenRefreshSeconds || 900; // Executes every 30 minutes if the user is not idle
    this.appConfig.msalAuth.timeouts = timeouts;
  }

  getConfig() {
    return this.appConfig;
  }

  shouldEnforceUserEntitlements(): boolean {
    return this.appConfig.enable_entitlement_enforcement;
  }

  isB2cEnabled(): boolean {
    return this.appConfig && this.appConfig.experimentalFeatures && this.appConfig.experimentalFeatures.enableB2CLogin;
  }
  
  isLandingPageEnabled():boolean{
    return this.appConfig && this.appConfig.experimentalFeatures && this.appConfig.experimentalFeatures.landingPage;
  }
}
